import axios from "axios";
//import {browserHistory} from "react-router";

// const
const REDIRECT_TO_VERSION_ADD_PAGE = "versionAdd/REDIRECT_TO_VERSION_ADD_PAGE";
const VERSION_ADD_UPDATE_DATA = "versionAdd/VERSION_ADD_UPDATE_DATA";
const VERSION_ADD_STORE_APPLICATION = "versionAdd/VERSION_ADD_STORE_APPLICATION";
const VERSION_ADD_STORE_MAJOR_VERSIONS = "versionAdd/VERSION_ADD_STORE_MAJOR_VERSIONS";
const VERSION_ADD_STORE_SOURCE_TYPES = "versionAdd/VERSION_ADD_STORE_SOURCE_TYPES";
const VERSION_ADD_TOGGLE_MODAL = "versionAdd/VERSION_ADD_TOGGLE_MODAL";
const VERSION_ADD_TOGGLE_LOADING = "versionAdd/VERSION_ADD_TOGGLE_LOADING";

// modal const
const VERSION_ADD_MODAL_SUCCESS_TITLE = "scenes_Application_VersionAdd_modal_success_title";
const VERSION_ADD_MODAL_FAIL_TITLE = "scenes_Application_VersionAdd_modal_fail_title";
const VERSION_ADD_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Application_VersionAdd_modal_submitSuccess_content";
const VERSION_ADD_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Application_VersionAdd_modal_submitFail_content";
const VERSION_ADD_MODAL_UPLOAD_FILE_SUCCESS_CONTENT = "scenes_Application_VersionAdd_modal_uploadFileSuccess_content";
const VERSION_ADD_MODAL_UPLOAD_FILE_FAIL_CONTENT = "scenes_Application_VersionAdd_modal_uploadFileFail_content";  //，是否重新上传？
const VERSION_ADD_MODAL_OK_LABEL = "scenes_Application_VersionAdd_modal_OK_label";
const VERSION_ADD_MODAL_CANCEL_LABEL = "scenes_Application_VersionAdd_modal_cancel_label";
const VERSION_ADD_MODAL_YES_LABEL = "scenes_Application_VersionAdd_modal_yes_label";
const VERSION_ADD_MODAL_NO_LABEL = "scenes_Application_VersionAdd_modal_no_label";


// reducer
export const versionAdd = (state = {
  loading: false,
  flag: "",
  rowKey: 1,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  applicationId: "",
  application: {
    id: "",
    name: "",
    type: {
      id: "",
      code: "",
      name: ""
    }
  },
  majorVersions: [],
  majorVersion: "",
  sourceTypes: [],

  version: "",
  sourceType: "",
  description: "",
  programFile: [],
  programFileId: "",
  helpFile: [],
  helpFileId: "",
  apiFile: [],
  apiFileId: "",
  testReportFile: [],
  testReportFileId: "",

  screenHeight: 320,
  visibleScreenshot: false,
  previewScreenshot: "",
  screenshots: [],
//权限配置
  checked: true,
  authorities: [{key: 0, code: "", name: "", description: ""}],


}, action) => {
  switch (action.type) {
    case REDIRECT_TO_VERSION_ADD_PAGE:
      return {
        ...state,
        applicationId: action.data
      };
    case VERSION_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case VERSION_ADD_STORE_APPLICATION:
      return {
        ...state,
        applicationId: action.data.id,
        application: action.data
      };
    case VERSION_ADD_STORE_MAJOR_VERSIONS:
      return {
        ...state,
        modalVisible: false,
        rowKey: 1,
        majorVersions: action.data,
        majorVersion: "",
        programFile: [],
        helpFile: [],
        apiFile: [],
        testReportFile: [],
        visibleScreenshot: false,
        previewScreenshot: "",
        screenshots: [],
        checked: true,
        authorities: [{key: 0, code: "", name: "", description: ""}]
      };
    case VERSION_ADD_STORE_SOURCE_TYPES:
      return {
        ...state,
        sourceTypes: action.data
      };
    case VERSION_ADD_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case VERSION_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：application.id
 */
export function redirectToPublishAppPage(applicationId) {
  return {
    type: REDIRECT_TO_VERSION_ADD_PAGE,
    data: applicationId
  };
}

/**
 * update data based on user input
 */
export const updateVersionAddData = (data) => {
  return {
    type: VERSION_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * check application and get majorVersions
 */
export const initVersionAdd = (data) => (dispatch) => {
  let applicationId = data.applicationId;
  dispatch(updateVersionAddData({
    name: "flag",
    value: data.flag
  }))
  if (applicationId !== null && applicationId !== undefined && applicationId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-application/getApplication/${applicationId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeApplication(response.data));
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
          this.props.history.push("/exception/415");
        }
      }
    );
    axios.get(`/api-application/getMajorVersionByApplicationId/${applicationId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeMajorVersions(response.data));
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
          this.props.history.push("/exception/415");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store application
 */
export const storeApplication = (application) => {
  return {
    type: VERSION_ADD_STORE_APPLICATION,
    data: application
  }
};

/**
 * store major versions
 */
export const storeMajorVersions = (majorVersions) => {
  return {
    type: VERSION_ADD_STORE_MAJOR_VERSIONS,
    data: majorVersions
  }
};

/**
 * get all sourceTypes
 */
export const getSourceTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getSourceType", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeSourceTypes(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all sourceTypes
 */
export const storeSourceTypes = (sourceTypes) => {
  return {
    type: VERSION_ADD_STORE_SOURCE_TYPES,
    data: sourceTypes
  }
};

/**
 * submit data
 */
export const createApplicationVersion = (data, history, flag) => (dispatch) => {
  dispatch(toggleLoading(true));
  let appId = data.applicationId;
  axios({
    method: "post",
    url: "/api-application/submitVersion",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "number": data.minorVersion,
      "version": data.version,
      "status": {"code": data.status},
      "sourceType": {"id": data.sourceType},
      "programFile": data.programFile,
      "containerPort": data.containerPort,
      "description": data.description,
      "screenHeight": 800,
      "screenshots": data.screenshots,
      "detailFiles": data.detailFiles,
      // "detailPics": data.detailPics,
      "releaseUserId": data.releaseUserId,
      "releaseUserName": data.releaseUserName,
      "releaseCompanyId": flag === "enterprise" ? data.releaseCompanyId : "00000000-0000-0000-0000-000000000000",
      "releaseCompanyName": (flag === "enterprise" ? data.releaseCompanyName : (flag === "platform" ? "中科云翼互联智造服务云平台" : (flag === "private" ? "" : data.releaseUserId))),
      "majorVersion": data.majorVersion === "-1" ? {
        "number": data.newMajor,
        "authorities": data.authorities,
        "createUserId": data.releaseUserId,
        "createUserName": data.releaseUserName,
        "createCompanyId": data.releaseCompanyId,
        "createCompanyName": data.releaseCompanyName,
        "application": {id: appId},
        "ifEnabled": true
      } : {
        "id": data.majorVersion
      },
      "ifEnabled": true
    },
  }).then(
    response => {
      if (response.status === 200) {
        console.log("success create new version");
        if(data.authorities.length>0){
          let authList = [];
          data.authorities.forEach(function(auth){
            var authData = {
              "app": response.data.majorVersionId,
              "appName": data.appName,
              "authName": auth.name,
              "authCode": auth.code,
              "authDescription": auth.description,
              "enterprise": data.enterprise,
              "status":{
                "code": "3",
                "name": "审核成功"}
            };
            authList.push(authData);
          });
          axios({
            url: `/api-user/authWithEnterprises`,
            method: "POST",
            data: authList
          })
        }
        let majorId = response.data.majorVersionId;
        let minorId = response.data.minorVersionId;
        let deployData = {
          "appId": appId,
          "appName": data.appName,
          "majorId": majorId,
          "minorId": minorId,
          "version": data.version,
          "url": data.release === "jar" ? data.programFile : data.url,
          "other": data.release === "url" ? data.menu : "",
          "containerPort": data.containerPort,
          "jenkinsProject": data.jenkinsProject,
          "gitlabProject": data.gitlabProject,
          "jdk": data.jdk
        };
        axios({
          url: `/api-tenant/app/saveInfo`,
          method: "POST",
          data: deployData
        }).then(
          response => {
            dispatch(toggleLoading(false));
            console.info("success submit version deploy");
            if (response.status === 200) {
              dispatch(toggleModal({
                modalVisible: true,
                modalTitle: VERSION_ADD_MODAL_SUCCESS_TITLE,
                modalContent: VERSION_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
                modalOk: VERSION_ADD_MODAL_OK_LABEL,
                modalCancel: VERSION_ADD_MODAL_CANCEL_LABEL,
                onOk: () => {
                  dispatch(toggleModal({
                    modalVisible: false
                  }));
                  history.push(`/console/application-edit?id=${appId}&flag=${flag}`);
                },
                onCancel: () => {
                  dispatch(toggleModal({
                    modalVisible: false
                  }));
                  history.push(`/console/application-edit?id=${appId}&flag=${flag}`);
                }
              }));
            } else {
              console.error("fail to submit version deploy");
              dispatch(toggleModal({
                modalVisible: true,
                modalTitle: VERSION_ADD_MODAL_FAIL_TITLE,
                modalContent: VERSION_ADD_MODAL_UPLOAD_FILE_FAIL_CONTENT,
                modalOk: VERSION_ADD_MODAL_OK_LABEL,
                modalCancel: VERSION_ADD_MODAL_CANCEL_LABEL,
                onOk: () => {
                  dispatch(toggleModal({
                    modalVisible: false
                  }))
                },
                onCancel: () => {
                  dispatch(toggleModal({
                    modalVisible: false
                  }))
                }
              }));
            }
          }
        );
      } else {
        dispatch(toggleLoading(false));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: VERSION_ADD_MODAL_SUCCESS_TITLE,
          modalContent: VERSION_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
          modalOk: VERSION_ADD_MODAL_OK_LABEL,
          modalCancel: VERSION_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            this.props.history.push(`/console/application-edit?id=${appId}&flag=${flag}`);
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            this.props.history.push(`/console/application-edit?id=${appId}&flag=${flag}`);
          }
        }));
      }
    }
  );
};

/**
 * return back
 */
export const returnToBack = () => (dispatch) => {
  // dispatch(showSuccessModal(false));
  // browserHistory.push("/appMarket");
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: VERSION_ADD_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: VERSION_ADD_TOGGLE_LOADING,
    data: show
  }
};
